import { render, staticRenderFns } from "./BaEcnList.vue?vue&type=template&id=cd475876&"
import script from "./BaEcnList.vue?vue&type=script&lang=js&"
export * from "./BaEcnList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports